import classNames from 'classnames';
import { CSSProperties, PropsWithChildren, useRef } from 'react';
import ReactModal from 'react-modal';

import { useUIMode } from 'client-web-sdk';

/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['light', 'dark'] }] */
import styles from './BaseModal.module.css';
export const BASE_MODAL_ANIMATION_DURATION_MS = 150;

export default function BaseModal({
  children,
  style,
  ...props
}: PropsWithChildren<ReactModal.Props>) {
  const uiMode = useUIMode();

  const lastChildrenRef = useRef(children);
  if (props.isOpen) {
    lastChildrenRef.current = children;
  }

  return (
    <ReactModal
      {...props}
      overlayClassName={classNames(
        styles.Overlay,
        props.overlayClassName,
        styles[uiMode],
        !props.isOpen && styles.closing,
      )}
      htmlOpenClassName={classNames(props.htmlOpenClassName)}
      style={{
        content: { ...style?.content },
        overlay: {
          ...style?.overlay,
          '--animation-duration': `${BASE_MODAL_ANIMATION_DURATION_MS}ms`,
        } as CSSProperties,
      }}
      closeTimeoutMS={BASE_MODAL_ANIMATION_DURATION_MS}
    >
      {props.isOpen ? children : lastChildrenRef.current}
    </ReactModal>
  );
}
